<template>
  <div class="modal-1">
    <button type="button" class="btn btn-primary  rounded-pill modal-1-button " @click="toggleModalMethod()"
            data-toggle="modal"
            :data-target="`#${generateModalId}`">
      {{ modalButtonText }}
    </button>

    <teleport to="body">
      <div class="modal fade " :id="generateModalId" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog" :class="modalSize">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-right"  v-if="showModal">
              <slot>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci asperiores dolor dolore dolores eaque
                eos et incidunt inventore ipsa, ipsum itaque libero magni omnis pariatur, quae quidem recusandae
                reprehenderit voluptates.
              </slot>
            </div>

          </div>
        </div>
      </div>
    </teleport>

  </div>
</template>

<script>
import {defineComponent} from 'vue'
import {generateRandomString} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import $ from 'jquery'


export default defineComponent({
  name: "Modal1",
  props: {
    modalSize: {
      options: ['modal-sm', 'modal-md', 'modal-lg', 'modal-xl'],
      default: 'modal-md'
    },
    modalButtonText: {default: 'مدال 1'}
  },
  data() {
    return {
      $,
      showModal: false
    }
  },
  computed: {
    generateModalId() {
      return `modal-${generateRandomString()}`
    }
  },
  methods: {
    toggleModalMethod() {
      this.showModal = !this.showModal
    },

  },
  mounted() {
    $(`#${this.generateModalId}`).on('hide.bs.modal', () => {
      this.toggleModalMethod()
    });
  }
})
</script>


<style scoped>

</style>